import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { act } from "@/lib/hooks";
import { api } from "@/lib/api";
import { Section, Field } from "@/components/common";

export function BillingEmail({ current, recipient, onSaved }) {
  const [email, setEmail] = useState(current || "");
  useEffect(() => setEmail(current || ""), [current]);
  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  const save = async () => { if (await act(() => api.put("/billing/email", { email: email.trim() }), "Billing email saved")) onSaved(); };
  return (
    <Section title="Billing email" testId="billing-email-section">
      <div className="space-y-3 p-5">
        <p className="flex items-start gap-2 text-sm text-slate-600"><Mail className="mt-0.5 h-4 w-4 shrink-0 text-[#2B7F77]" />This address receives all billing-related emails: invoices and payment links, payment reminders, payment failure and dunning notices, cancellation and lockout notices, and Paystack receipts.</p>
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end">
          <div className="w-full sm:max-w-md"><Field label="Billing email"><Input type="email" data-testid="billing-email-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="accounts@yourcompany.com" /></Field></div>
          <Button data-testid="billing-email-save" disabled={!valid || email.trim().toLowerCase() === (current || "").toLowerCase()} onClick={save} className="bg-[#13294B] hover:bg-[#1c3a66]">Save</Button>
        </div>
        {!current && recipient && <p className="text-xs text-slate-500" data-testid="billing-email-fallback">No billing email set. Billing emails currently go to the workspace admin, {recipient}.</p>}
      </div>
    </Section>);
}
